import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { INROUTES, EXTERNAL_LINKS } from './../../common/links';

import exLinkTo from '../../utils/exLinkTo';
import Copyright from './../../components/Copyright';

import IcInstagram from './../../assets/icon/bi-instagram.svg';
import IcSmartstore from './../../assets/icon/bi-naver-store.svg';
import IcZcard from './../../assets/icon/bi-zcard.svg';
import IcKakao from './../../assets/icon/bi-kakako-channel.svg';
import IcNaver from './../../assets/icon/bi-naver.svg';
import IcArrow from './../../assets/icon/ic-arrow.svg';


const renderButton = (type) => {
    let button;

    switch(type){
        case 'kakao_channel':
            button = (<button type="button" name="link" value="KAKAOCH" className="btn" onClick={exLinkTo}><i className="icon"><img src={IcKakao} alt="Kakao Channel" className="svg" /></i><span className="name">문의하기</span></button>);
        break;
        case 'buy_skytone':
            button = (<button type="button" name="link" value="BUYSKYTONE" className="btn" onClick={exLinkTo}><i className="icon"><img src={IcNaver} alt="NAVER" className="svg" /></i><span className="name">구매하기</span></button>)
        break;
        case 'module':
            button = (<Link to={INROUTES.SKYTONE_MODULE} className="btn point" target="_self" rel="noopener noreferrer"><strong className="name dfont">CRAFT NOW : LET'S GET STARTED</strong><i className="icon"><img src={IcArrow} alt="→" className="svg" /></i></Link>)
        break;
        case 'frame':
            button = (<Link to={INROUTES.SKYTONE_FRAME} className="btn point" target="_self" rel="noopener noreferrer"><strong className="name">02. 프레임 조립</strong><i className="icon"><img src={IcArrow} alt="→" className="svg" /></i></Link>)
        break;
        case 'wifi':
            button = (<Link to={INROUTES.SKYTONE_WIFI} className="btn point" target="_self" rel="noopener noreferrer"><strong className="name">03. Wi-Fi 설정</strong><i className="icon"><img src={IcArrow} alt="→" className="svg" /></i></Link>)
        break;
        case 'setting':
            button = (<Link to={INROUTES.SKYTONE_SETTING} className="btn point" target="_self" rel="noopener noreferrer"><strong className="name">04. 기능설정</strong><i className="icon"><img src={IcArrow} alt="→" className="svg" /></i></Link>)
        break;
        case 'faq':
            button = (<Link to={INROUTES.SKYTONE_FAQ} className="btn point" target="_self" rel="noopener noreferrer"><strong className="name">05. FAQ</strong><i className="icon"><img src={IcArrow} alt="→" className="svg" /></i></Link>)
        break;
        default:
            button = (<></>);
    }
    return button
}

const Footer = ({page}) => { 
    const location = page ? page.toLowerCase() : 'home'
    const [buttons, setButtons] = useState(renderButton('kakao_channel')+renderButton('buy_skytone'))  
    useEffect(() => {
        let combinedButtons;
        switch(location){
            case 'about':  
                combinedButtons = (
                    <>
                    {renderButton('module')}
                    </>
                );
            break
            case 'module':   
                combinedButtons = (
                    <>
                    {renderButton('kakao_channel')}
                    {renderButton('frame')}
                    </>
                );
            break
            case 'frame':                
                combinedButtons = (
                    <>
                    {renderButton('kakao_channel')}
                    {renderButton('wifi')}
                    </>
                );
            break
            case 'wifi':        
                combinedButtons = (
                    <>            
                    {renderButton('kakao_channel')}
                    {renderButton('setting')}
                    </>
                )
            break
            case 'setting':       
                combinedButtons = (
                    <>            
                    {renderButton('kakao_channel')}
                    {renderButton('faq')}
                    </>
                ) 
            break
            default:      
                combinedButtons = (
                    <>            
                    {renderButton('kakao_channel')}
                    {renderButton('buy_skytone')}
                    </>
                ) 
        }
        setButtons(<div className="button-box">{combinedButtons}</div>)
    }, [location])

    return (
        <footer className="footer">
            <div className="wrap">
                {buttons}
            </div>
            <div className="ic-btn-group">
                <a href={EXTERNAL_LINKS.INSTAGRAM} target="_blank" rel="noreferrer" className="ic-btn"><button type="button"><i className="icon"><img src={IcInstagram} alt="Instagram" className="svg" /></i></button></a>
                <a href={EXTERNAL_LINKS.SMARTSTORE} target="_blank" rel="noreferrer" className="ic-btn"><button type="button"><i className="icon"><img src={IcSmartstore} alt="NAVER Smart Store" className="svg" /></i></button></a>
                <a href={EXTERNAL_LINKS.ZCARD} target="_blank" rel="noreferrer" className="ic-btn"><button type="button"><i className="icon"><img src={IcZcard} alt="ZCARD" className="svg" /></i></button></a>
            </div>
            <Copyright />
        </footer>
    );
    
};


export default Footer;